import { Field } from "formik";
import React from "react";
import VStack from "../layout/VStack/VStack";

const SelectInput = ({
  label,
  name,
  options,
  placeholder,
  required,
  isFormik = true,
  className,
  style,
  gap = 4,
  onChange,
  value,
  errorMessage,
}) => {
  if (isFormik) {
    return (
      <VStack style={style} gap={gap}>
        <label className="text-sm">
          {label}
          <span style={{ color: required ? "red" : "black" }}>
            {required ? "*" : ""}
          </span>
        </label>
        <Field name={name}>
          {({ field }) => (
            <select
              {...field}
              onChange={(e) => {
                field.onChange(e); // Update Formik state
                onChange?.(e); // Call custom onChange if provided
              }}
              style={{ width: "100%", margin: 0, textAlign: "left" }}
            >
              <option value="">{placeholder}</option>
              {options?.map((option) => (
                <option
                  key={option.value}
                  value={option.value}
                  disabled={option.disabled}
                >
                  {option.label}
                </option>
              ))}
            </select>
          )}
        </Field>

        {errorMessage && <div style={{ color: "red" }}>{errorMessage}</div>}
      </VStack>
    );
  }

  return (
    <VStack style={style} gap={gap}>
      <label className="text-sm">
        {label}
        <span style={{ color: required ? "red" : "black" }}>
          {required ? "*" : ""}
        </span>
      </label>
      <select
        style={{ width: "100%" }}
        name={name}
        onChange={onChange}
        value={value}
      >
        <option value="">{placeholder}</option>
        {options?.map((option) => (
          <option
            key={option.value}
            value={option.value}
            disabled={option.disabled}
          >
            {option.label}
          </option>
        ))}
      </select>
      {errorMessage && <div style={{ color: "red" }}>{errorMessage}</div>}
    </VStack>
  );
};

export default SelectInput;
